import axios from "axios";

export const voiceService = {
  async processAudio(audioBlob) {
    if (!process.env.REACT_APP_OPENAI_API_KEY) {
      throw new Error("OpenAI API key is not configured");
    }

    // Step 1: Transcribe the audio
    const formData = new FormData();
    formData.append("file", audioBlob, "audio.webm");
    formData.append("model", "whisper-1");

    const transcriptionResponse = await axios.post(
      "https://api.openai.com/v1/audio/transcriptions",
      formData,
      {
        headers: {
          Authorization: `Bearer ${process.env.REACT_APP_OPENAI_API_KEY}`,
        },
      }
    );

    const transcriptionData = transcriptionResponse.data;

    if (!transcriptionData.text) {
      throw new Error("Failed to transcribe audio");
    }

    // Step 2: Analyze the transcription
    const analysisResponse = await axios.post(
      "https://api.openai.com/v1/chat/completions",
      {
        model: "gpt-4",
        messages: [
          {
            role: "system",
            content: `You are a financial assistant. Interpret the user's statement as a financial transaction. 
                      By default, classify transactions as "expense" unless explicitly stated as "income" (e.g., "received" or "earned"). 
                      Return a JSON object with:
                      - type (string): "expense" or "income" (default to "expense" if unclear)
                      - amount (number): The transaction amount
                      - category (string): One of [Transportation, Food, Shopping, Entertainment, Utilities, Other]
                      - description (string): A brief description of the transaction`,
          },
          {
            role: "user",
            content: transcriptionData.text,
          },
        ],
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${process.env.REACT_APP_OPENAI_API_KEY}`,
        },
      }
    );

    const analysisData = analysisResponse.data;

    if (!analysisData.choices?.[0]?.message?.content) {
      throw new Error("Failed to analyze transcription");
    }

    // Parse and return the analysis result
    try {
      const parsedAnalysis = JSON.parse(analysisData.choices[0].message.content);

      return {
        type: parsedAnalysis.type || "expense", // Default to expense
        amount: Number(parsedAnalysis.amount),
        category: parsedAnalysis.category || "Other",
        description: parsedAnalysis.description || "No description provided",
      };
    } catch (error) {
      throw new Error("Failed to parse expense analysis");
    }
  },
};
